import React from "react";
import PropTypes from "prop-types";
import { HeaderPortal, useSetHeaderRecordName } from "../../../components/ui-components/HeaderSlot.jsx";
import { primaryButtonCls, secondaryButtonCls } from "../../../components/ui-components/buttonStyles.js";

// The source builder's header: a plain title on the page (no grey header strip, no back
// chevron) with the Cancel/Save actions hoisted into the global TopBar's top row — styled like
// the primary/secondary buttons on /approvals/:id and /control-policies/approval-policies/:id.
const SourceCockpitHeader = ({ title, onCancel, onSave, saveDisabled, saving }) => {
  useSetHeaderRecordName(title || null);

  return (
    <>
      {/* Title lives in the header's row-1 title slot. */}
      <HeaderPortal slot="title">
        <div className="flex items-center gap-3 min-w-0">
          <div className="text-[20px] leading-[1.4] font-extrabold tracking-[-0.015em] text-text truncate font-['Plus_Jakarta_Sans',sans-serif]">
            {title}
          </div>
        </div>
      </HeaderPortal>

      <HeaderPortal>
        <div className="flex items-center gap-2.5">
          <button type="button" className={secondaryButtonCls} onClick={onCancel}>
            Cancel
          </button>
          <button
            type="button"
            className={primaryButtonCls}
            onClick={onSave}
            disabled={saveDisabled || saving}
          >
            {saving ? "Saving…" : "Save source"}
          </button>
        </div>
      </HeaderPortal>
    </>
  );
};

SourceCockpitHeader.propTypes = {
  title: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  saveDisabled: PropTypes.bool,
  saving: PropTypes.bool,
};

export default SourceCockpitHeader;
